import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2 } from "@angular/core";
import { FieldTypeConfig } from "@ngx-formly/core";
import { FieldType } from "@ngx-formly/material/form-field";

@Component({
  selector: "lib-formly-masked-type",
  standalone: false,
  templateUrl: "./formly-masked-type.component.html",
  styleUrls: ["./formly-masked-type.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyMaskedTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  maskTypes: MaskTypes = {};

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }
  ngOnInit(): void {
    if (this.formControl.value) {
      const parentElement = this.element.nativeElement.closest(".mat-mdc-form-field");
      if (parentElement) {
        this.renderer.addClass(parentElement, "masked-input");
      }
    }
  }

  get type() {
    return this.props.type || "text";
  }

  get dropSpecialCharacters(): boolean {
    return this.props.dropSpecialCharacters ? this.props.dropSpecialCharacters : false;
  }

  get prefix() {
    return this.props.prefix || "";
  }

  get suffix() {
    return this.props.suffix || "";
  }

  get mask() {
    return this.props.mask || "";
  }

  // Objects only: props.pattern also holds the JSON Schema regex, and a string throws in ngx-mask.
  get pattern(): any {
    const patterns = this.props.maskPatterns ?? this.props.pattern;
    return patterns && typeof patterns === "object" ? patterns : "";
  }

  get placeHolder() {
    return this.props.placeholder || "";
  }

  get showMaskTyped(): boolean {
    return this.props.showMaskTyped || false;
  }

  get specialCharacters() {
    return this.props.specialCharacters || "";
  }
}

export interface MaskTypes {
  [k: string]: {
    mask: string;
    pattern: any;
    symbol: string;
    prefix: string;
    suffix: string;
    dropSpecialCharacters: boolean;
    showMaskTyped: boolean;
    clearIfNotMatch: boolean;
    specialCharacters: any;
  };
}
